import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Platisma
// 10 Básicas + 10 Generales + 10 Complejas

export const platismaQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10331,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué significa el nombre 'platisma'?",
    options: [
      "Músculo ancho",
      "Músculo plano",
      "Músculo superficial",
      "Músculo del cuello"
    ],
    correctAnswer: 1,
    explanation: "El nombre 'platisma' significa 'músculo plano' en griego, refiriéndose a su forma laminar delgada. Es el músculo más superficial del cuello y forma parte de la musculatura mimética facial, aunque se origina en el cuello."
  },
  
  {
    id: 10332,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina el platisma?",
    options: [
      "Clavícula y acromion",
      "Fascia del pectoral mayor",
      "Borde inferior de la mandíbula",
      "Apófisis mastoides"
    ],
    correctAnswer: 1,
    explanation: "El platisma se origina en la fascia del músculo pectoral mayor y deltoides, específicamente de la segunda a sexta costillas. Esta amplia inserción torácica le permite cubrir toda la región cervical anterior."
  },
  
  {
    id: 10333,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la función principal del platisma?",
    options: [
      "Flexión del cuello",
      "Tensar la piel del cuello",
      "Depresión de la mandíbula",
      "Rotación cervical"
    ],
    correctAnswer: 2,
    explanation: "La función principal del platisma es la depresión de la mandíbula y tensar la piel del cuello. Actúa como músculo cutáneo que puede deprimir la comisura labial y crear arrugas en el cuello cuando se contrae fuertemente."
  },
  
  {
    id: 10334,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervio inerva al platisma?",
    options: [
      "Nervio facial (VII par)",
      "Nervio accesorio (XI par)",
      "Plexo cervical (C2-C4)",
      "Nervio hipogloso (XII par)"
    ],
    correctAnswer: 0,
    explanation: "El platisma es inervado por el nervio facial (VII par craneal), específicamente por ramas cervicales del facial. Esta inervación facial explica por qué el platisma se considera parte de la musculatura mimética, aunque se localiza en el cuello."
  },
  
  {
    id: 10335,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria irriga principalmente al platisma?",
    options: [
      "Arteria carótida externa",
      "Arteria facial",
      "Arteria submentoniana",
      "Arteria tiroidea superior"
    ],
    correctAnswer: 2,
    explanation: "La arteria submentoniana, rama de la arteria facial, irriga principalmente al platisma. Esta arteria superficial discurre por el triángulo submandibular y proporciona irrigación a la piel y músculos superficiales del cuello."
  },
  
  {
    id: 10336,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura se encuentra profunda al platisma?",
    options: [
      "Fascia cervical superficial únicamente",
      "Músculos infrahioideos",
      "Vena yugular externa",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "Profundo al platisma se encuentra la fascia cervical superficial, los músculos infrahioideos (esternohioideo, esternotiroideo, etc.), y la vena yugular externa. Esta disposición explica por qué el platisma es un importante punto de referencia superficial en cirugía cervical."
  },
  
  {
    id: 10337,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué tipo de músculo es el platisma?",
    options: [
      "Músculo cutáneo",
      "Músculo esquelético",
      "Músculo liso",
      "Músculo cardíaco"
    ],
    correctAnswer: 0,
    explanation: "El platisma es un músculo cutáneo, uno de los pocos que se insertan directamente en la piel. Su contracción produce movimientos de la piel del cuello y es responsable de expresiones faciales como el 'gesto de horror' o tragar con dificultad."
  },
  
  {
    id: 10338,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se inserta el platisma?",
    options: [
      "Piel del mentón y comisura labial",
      "Borde inferior de la mandíbula",
      "Apófisis mastoides",
      "Todas las anteriores"
    ],
    correctAnswer: 0,
    explanation: "El platisma se inserta en la piel del mentón, comisura labial y piel del cuello. Esta inserción cutánea permite al músculo deprimir la mandíbula y crear pliegues en la piel del cuello cuando se contrae."
  },
  
  {
    id: 10339,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué papel juega el platisma en la expresión facial?",
    options: [
      "Sonrisa",
      "Gesto de disgusto o miedo",
      "Elevación de cejas",
      "Cierre de ojos"
    ],
    correctAnswer: 1,
    explanation: "El platisma produce el 'gesto de disgusto' o 'miedo', deprimindo la comisura labial y creando arrugas verticales en el cuello. Es parte de expresiones de tensión emocional o física intensa."
  },
  
  {
    id: 10340,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Por qué el platisma es importante en procedimientos estéticos?",
    options: [
      "Por su función en el envejecimiento",
      "Por su visibilidad en el cuello",
      "Por su respuesta a tratamientos",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El platisma es importante en procedimientos estéticos porque es visible en el cuello, contribuye al envejecimiento cervical (bandas platismales), y responde bien a tratamientos como toxina botulínica o lifting cervical. Su hipertrofia puede crear 'cuello de pavo'."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10341,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuye el platisma a la expresión emocional?",
    options: [
      "Solo expresiones negativas",
      "Expresiones de tensión y miedo",
      "Todas las expresiones faciales",
      "No contribuye a expresiones"
    ],
    correctAnswer: 1,
    explanation: "El platisma contribuye específicamente a expresiones de tensión, miedo y disgusto. Su contracción bilateral produce el típico 'gesto de horror' con comisuras labiales deprimidas y piel del cuello arrugada."
  },
  
  {
    id: 10342,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructuras vasculonerviosas pasan sobre el platisma?",
    options: [
      "Vena yugular externa",
      "Arteria facial",
      "Ramas cervicales del facial",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "Sobre el platisma pasan la vena yugular externa, ramas de la arteria facial y ramas cervicales del nervio facial. Esta disposición superficial explica por qué el platisma es vulnerable a lesiones vasculares durante procedimientos cutáneos."
  },
  
  {
    id: 10343,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué rama específica irriga el platisma?",
    options: [
      "Ramas perforantes de la arteria torácica interna",
      "Arteria submentoniana",
      "Ramas cervicales transversas",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El platisma recibe irrigación de ramas perforantes de la arteria torácica interna, arteria submentoniana y ramas cervicales transversas. Esta rica vascularización explica su buena cicatrización y resistencia a la necrosis."
  },
  
  {
    id: 10344,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Cómo se distribuye la inervación facial en el platisma?",
    options: [
      "Rama cervical del facial únicamente",
      "Múltiples ramas cervicales del facial",
      "Rama mandibular del facial",
      "Nervio auricular mayor"
    ],
    correctAnswer: 1,
    explanation: "El platisma recibe inervación de múltiples ramas cervicales del nervio facial. Esta distribución redundante explica por qué la parálisis completa del platisma es rara, requiriendo lesión extensa del nervio facial."
  },
  
  {
    id: 10345,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante anatómica más común del platisma?",
    options: [
      "Ausencia bilateral",
      "Inserción ausente en mentón",
      "Fusión con depresores anguli oris",
      "Todas son comunes"
    ],
    correctAnswer: 2,
    explanation: "La fusión con los depresores anguli oris es la variante más común del platisma, ocurriendo en 40-50% de la población. Esta fusión puede crear un pliegue más pronunciado en la comisura labial durante expresiones emocionales."
  },
  
  {
    id: 10346,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué condición patológica afecta al platisma?",
    options: [
      "Parálisis facial",
      "Bandas platismales",
      "Contractura postraumática",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El platisma puede afectarse por parálisis facial (pérdida de tono), bandas platismales (hipertrofia visible) y contractura postraumática. La parálisis facial produce asimetría en expresiones que involucran el cuello."
  },
  
  {
    id: 10347,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué capa embrionaria se desarrolla el platisma?",
    options: [
      "Mesodermo somítico",
      "Mesodermo lateral",
      "Ectodermo",
      "Mesénquima de la segunda arco faríngeo"
    ],
    correctAnswer: 3,
    explanation: "El platisma se desarrolla del mesénquima de la segunda arco faríngeo, al igual que otros músculos faciales. Su desarrollo embrionario explica su inervación facial y su función como músculo mimético, aunque se localiza en el cuello."
  },
  
  {
    id: 10348,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción aproximada de fibras musculares tiene el platisma?",
    options: [
      "90% fibras tipo I",
      "70% fibras tipo II",
      "60% tipo I, 40% tipo II",
      "50% tipo I, 50% tipo II"
    ],
    correctAnswer: 1,
    explanation: "El platisma tiene predominio de fibras tipo II (70%), adaptadas para contracciones rápidas y potentes en expresiones faciales. Como músculo cutáneo delgado, requiere fuerza más que resistencia para movimientos rápidos."
  },
  
  {
    id: 10349,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué fascia cubre al platisma?",
    options: [
      "Fascia cervical superficial",
      "Fascia cervical media",
      "Aponeurosis cervical profunda",
      "Fascia superficial únicamente"
    ],
    correctAnswer: 0,
    explanation: "El platisma está cubierto por la fascia cervical superficial, que es la capa más externa del cuello. Esta fascia contiene el platisma y continúa con la fascia superficial del tronco y cara."
  },
  
  {
    id: 10350,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el platisma es importante en la respiración?",
    options: [
      "Es un músculo respiratorio accesorio",
      "Ayuda en la inspiración forzada",
      "Fija la laringe",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "El platisma actúa como músculo respiratorio accesorio durante la inspiración forzada, especialmente en pacientes con obstrucción de vías aéreas. Su contracción ayuda a dilatar las vías aéreas superiores por tracción cutánea."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10351,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con parálisis facial presenta asimetría en expresiones cervicales. ¿Qué músculo está afectado?",
    options: [
      "Esternocleidomastoideo",
      "Platisma",
      "Milohioideo",
      "Digástrico"
    ],
    correctAnswer: 1,
    explanation: "La asimetría en expresiones cervicales en parálisis facial indica afectación del platisma, inervado por el nervio facial. El paciente no puede deprimir la comisura labial del lado afectado ni crear arrugas cervicales."
  },
  
  {
    id: 10352,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con 'cuello de pavo' presenta bandas verticales prominentes. ¿Qué estructura está hipertrofiada?",
    options: [
      "Vientre anterior del digástrico",
      "Músculos infrahioideos",
      "Platisma",
      "Fascia cervical superficial"
    ],
    correctAnswer: 2,
    explanation: "El 'cuello de pavo' se debe a hipertrofia y ptosis del platisma, creando bandas verticales prominentes. Es más común en mujeres mayores y puede corregirse con procedimientos estéticos como lifting cervical o toxina botulínica."
  },
  
  {
    id: 10353,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se utiliza para corrección estética del platisma ptósico?",
    options: [
      "Lifting cervical con platisma-plastia",
      "Toxina botulínica",
      "Liposucción cervical",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "La corrección del platisma ptósico puede hacerse con lifting cervical (platisma-plastia), toxina botulínica para relajación, o liposucción cervical combinada. La platisma-plastia reposiciona y tensa el músculo para eliminar bandas."
  },
  
  {
    id: 10354,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía cervical, ¿qué hallazgo confirma atrofia del platisma por parálisis facial?",
    options: [
      "Engrosamiento muscular",
      "Disminución del grosor y ecogenicidad",
      "Aumento de vascularización",
      "Calcificaciones"
    ],
    correctAnswer: 1,
    explanation: "La atrofia del platisma por parálisis facial muestra disminución del grosor y ecogenicidad en ecografía. Es un hallazgo útil para evaluar la cronicidad y severidad de la lesión del nervio facial."
  },
  
  {
    id: 10355,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué complicación puede causar la inyección de toxina botulínica en el platisma?",
    options: [
      "Disfagia",
      "Dificultad para expresiones faciales",
      "Ptosis mandibular",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La toxina botulínica en el platisma puede causar dificultad para expresiones faciales que involucran el cuello. La dosis debe ser precisa para evitar parálisis excesiva que afecte la mímica facial."
  },
  
  {
    id: 10356,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente post-ritidectomía presenta parálisis temporal del platisma. ¿Qué explica esto?",
    options: [
      "Lesión del nervio facial",
      "Isquemia postoperatoria",
      "Hematoma compresivo",
      "Todas las anteriores"
    ],
    correctAnswer: 0,
    explanation: "La parálisis temporal del platisma post-ritidectomía indica tracción o sección inadvertida de ramas cervicales del nervio facial. La recuperación ocurre en semanas a meses. Es una complicación reconocida del lifting cervical."
  },
  
  {
    id: 10357,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación EMG muestra actividad eléctrica normal del platisma en reposo. ¿Qué patología neuromuscular se excluye?",
    options: [
      "Miastenia gravis",
      "Esclerosis lateral amiotrófica",
      "Parálisis facial central",
      "Distrofia muscular"
    ],
    correctAnswer: 1,
    explanation: "La actividad eléctrica normal del platisma en reposo excluye esclerosis lateral amiotrófica (ELA), donde se observa fasciculaciones y actividad anormal. El platisma es útil para EMG cervical por su accesibilidad."
  },
  
  {
    id: 10358,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué abordaje se utiliza para biopsia del platisma?",
    options: [
      "Abordaje intraoral",
      "Incisión horizontal en cuello inferior",
      "Abordaje endoscópico",
      "Biopsia por punción"
    ],
    correctAnswer: 1,
    explanation: "La biopsia del platisma se realiza con incisión horizontal en el cuello inferior, paralela a los pliegues cutáneos. Es útil para evaluación de miopatías inflamatorias o enfermedades sistémicas que afectan músculos cutáneos."
  },
  
  {
    id: 10359,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM cervical estética, ¿qué evaluación se realiza del platisma?",
    options: [
      "Grosor muscular",
      "Posición de las bandas",
      "Grado de ptosis",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "La RM cervical estética evalúa grosor muscular, posición de las bandas platismales y grado de ptosis del platisma. Es útil para planificar procedimientos estéticos y evaluar resultados postoperatorios."
  },
  
  {
    id: 10360,
    muscle: 'platisma',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Paciente con hipertrofia compensatoria del platisma contralateral. ¿Qué explica este hallazgo?",
    options: [
      "Parálisis facial homolateral",
      "Uso asimétrico en expresiones",
      "Postura compensatoria",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "La hipertrofia compensatoria del platisma contralateral ocurre por parálisis facial homolateral, uso asimétrico en expresiones y postura compensatoria. El músculo contralateral se sobrecarga para mantener expresiones faciales simétricas."
  }
];
